import { Directive, Input, EventEmitter, ElementRef, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appFocus]',
  standalone: false,
})
export class FocusDirective implements OnInit, OnDestroy {
  private element = inject(ElementRef);

  @Input() appFocus: EventEmitter<boolean>;
  focusSubscription: Subscription;

  ngOnInit() {
    if (this.appFocus) {
      this.focusSubscription = this.appFocus.subscribe((event) => {
        window.setTimeout(() => {
          this.element.nativeElement.focus();
        }, 10);
      });
    }
  }

  ngOnDestroy() {
    if (!!this.focusSubscription) {
      this.focusSubscription.unsubscribe();
    }
  }
}
